import React, { useEffect, useState } from "react";
import "./Feed.css";
import "../Home/Home.css";
import SearchIcon from "@mui/icons-material/Search";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import imgArticle from "../../media/ICONS THEMATIQUE/Fichier 5_1.png"
import { addFavorite, getFeedArticles, getFeedReviews, getFriendsArticles, getFriendsReviews, getOriginArticleFromLink, removeFavorite } from "../../HTTP/articles";
import { formatDateExtended, goToStaticPage, removeHtmlTags } from "../../Helper/utils";
import Pagination from "../../Helper/Pagination";
import ReviewBlocks from "../Review/ReviewBlocks";
import { getUserCountry } from "../../HTTP/countries";
import { sendArticleReadNotification } from "../../HTTP/user";
import ForumFavorites from "./ForumFavorites";
import RecommendToFriendPopup from "../Common/RecommendToFriendPopup";
import { PUBLISHED_VISIBILITY_OPTIONS } from "../../Helper/visibilityOptions";
import useCurrentLanguage from "../../Helper/useCurrentLanguage";
//import DropDownMenuPrivacy from '../DropDownMenus/DropDownMenuPrivacy'; // Assurez-vous que le chemin est correct

const Feed = () => {
  const currentLanguage = useCurrentLanguage();
  const isFrenchLanguage = currentLanguage.startsWith("fr");

  const CountBadge = ({ positionClassName, backgroundColor, count, label }) => (
    <span
      className={`absolute ${positionClassName} min-w-[28px] h-7 px-2 rounded-full text-white text-sm font-bold flex items-center justify-center shadow-md z-10 whitespace-nowrap`}
      style={{ backgroundColor }}
    >
      {label} : {count || 0}
    </span>
  );

  const user = JSON.parse(localStorage.getItem("user"));
  const url = new URL(window.location.href)
      if (url.searchParams.get('articlepage') === null) {
          url.searchParams.set('articlepage', 1);
          window.history.pushState({}, '', url);
      }
      if (url.searchParams.get('reviewpage') === null) {
        url.searchParams.set('reviewpage', 1);
        window.history.pushState({}, '', url);
    }
  const [searchTerm, setSearchTerm] = useState(url.searchParams.get('query') === null ? '' : url.searchParams.get('query'));
  const [launchSearch, setLaunchSearch] = useState(false);
  const [currentArticlePage, setCurrentArticlePage] = useState(parseInt(url.searchParams.get('articlepage')));
  const [currentReviewPage, setCurrentReviewPage] = useState(parseInt(url.searchParams.get('reviewpage')));
  const [articlesPerPage] = useState(4);
  const [reviewsPerPage] = useState(3);
  const [articles, setArticles] = useState({count:0, rows:[]});
  const [articleReady, setArticleReady] = useState(false);
  const [reviews, setReviews] = useState({count:0, rows:[]});
  const [reviewsReady, setReviewsReady] = useState(false);
  const [tab, setTab] = useState("shared");
  const showArticles = tab === "articles";
  const [articleVisible, setArticleVisible] = useState(1);
  const [reviewVisible, setReviewVisible] = useState(1);
  const [selectedArticleIdForRecommendation, setSelectedArticleIdForRecommendation] = useState(null);
  const isUserSubscribed = JSON.parse(localStorage.getItem("subscriptions")) !== null

  useEffect(() => {
    setArticleReady(false)
    const funArticles = async () => {
      const resArticles = isUserSubscribed ? await getFeedArticles(user.id, (currentArticlePage - 1) * articlesPerPage, currentArticlePage * articlesPerPage, articleVisible, searchTerm) : await getFriendsArticles(user.id, (currentArticlePage - 1) * articlesPerPage, currentArticlePage * articlesPerPage, searchTerm)
      setArticles(resArticles)
      setArticleReady(true)
    }
    setReviewsReady(false)
    const funReviews = async () => {
      const resReviews = isUserSubscribed ? await getFeedReviews(user.id, (currentReviewPage - 1) * reviewsPerPage, currentReviewPage * reviewsPerPage, reviewVisible, searchTerm) : await getFriendsReviews(user.id, (currentReviewPage - 1) * reviewsPerPage, currentReviewPage * reviewsPerPage, searchTerm)
      setReviews(resReviews)
      setReviewsReady(true)
    }
    funArticles()
    funReviews()
    setLaunchSearch(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentArticlePage, currentReviewPage, launchSearch, articlesPerPage, reviewsPerPage, isUserSubscribed, user.id, articleVisible, reviewVisible])
  
  const handleSearch = (e) => {
    e.preventDefault();
    if (url.searchParams.get('query') === null) {
      url.searchParams.set('query', searchTerm);
    } else {
      url.searchParams.set('query', searchTerm);
    }
    window.history.pushState({}, '', url);
    setLaunchSearch(true);
  };

  const articlePaginate = (pageNumber) => {
    url.searchParams.set('articlepage', pageNumber);
    window.history.pushState({}, '', url);
    setCurrentArticlePage(pageNumber);
  };

  const reviewPaginate = (pageNumber) => {
    url.searchParams.set('reviewpage', pageNumber);
    window.history.pushState({}, '', url);
    setCurrentReviewPage(pageNumber);
  };

  const handleViewArticle = (id) => {
    goToStaticPage(true, id);
  }

  const [favorites, setFavorites] = useState(JSON.parse(localStorage.getItem('favorites') || []));

  const handleArticleToFavorite = async (title, link, image, country, date, description) => {
    const countryFromFavorite = await getOriginArticleFromLink(link);
    const favorite = {
      title: title,
      link: link,
      image: image || "",
      country: countryFromFavorite.country || country,
      publication_date: date,
      description: description
    };

    try {
      const res = await addFavorite(favorite);
      if (res.ok === true) {
        favorite.id = res.id;
        const updatedFavorites = [favorite, ...favorites];
        setFavorites(updatedFavorites);
        localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
        alert('Article added to favorites !');
      }
    } catch (error) {
      console.error('An error has occured when adding the favorite', error);
      alert('An error has occured when adding the favorite');
    }
  };

  const handleRemoveFromFavorite = async (link) => {
    try {
      const res = await removeFavorite({ link });
      if (res) {
        console.log(favorites)
        const updatedFavorites = favorites.filter(fav => fav.link !== link);
        console.log(updatedFavorites)
        setFavorites(updatedFavorites);
        localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
        alert('Article removed from favorites !');
      }
    } catch (error) {
      console.error('An error has occured when deleting the favorite', error);
      alert('An error has occured when deleting the favorite');
    }
  };

  const handleSendArticleNotification = async (friendId) => {
    if (!selectedArticleIdForRecommendation || !friendId) return false;
    const res = await sendArticleReadNotification(selectedArticleIdForRecommendation, friendId);
    if (res) {
      alert("Notification envoyee");
      return true;
    }
    alert("Erreur lors de l'envoi de la notification");
    return false;
  };

  const ArticleCard = ({ articleId, imageUrl, author, authorProfilePicture, authorId, title, text, date, likesCount, commentsCount }) => {
    const articleLink = `https://static.zemus.info/article/?id=${articleId}&readerid=${user.id}`;
    const isFavorite = favorites.some(fav => fav.link === articleLink);

    const handleFavoriteClick = async () => {
      const authorCountry = await getUserCountry(authorId);
      if (isFavorite) {
        handleRemoveFromFavorite(articleLink);
      } else {
        handleArticleToFavorite(
          title,
          articleLink,
          imageUrl,
          authorCountry.country || user.country,
          new Date().toISOString().replace("T", " ").slice(0, 19),
          text.length > 150 ? text.slice(0, 50) + "..." : text
        );
      }
    };

    return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden transition duration-300 ease-in-out transform hover:-translate-y-1 hover:shadow-xl h-full relative">
      <CountBadge positionClassName="top-2 left-2" backgroundColor="#2563eb" count={commentsCount} label="Commentaires" />
      <CountBadge positionClassName="top-2 right-2" backgroundColor="#ef4444" count={likesCount} label="Likes" />
      <div className="flex flex-col h-full">
      <button onClick={() => handleViewArticle(articleId)}>
        <img
          className="w-full h-48 object-cover flex-shrink-0"
          src={imageUrl === null ? imgArticle : imageUrl}
          alt={title}
        />
      </button>
        <div className="p-4 flex-grow flex flex-col">
          <button onClick={() => handleViewArticle(articleId)} className="flex-grow">
            <h3 className="text-lg font-semibold mb-2">{title}</h3>
            <p className="text-gray-600 flex-grow">
              {text.length > 150 ? text.slice(0, 50) + "..." : text}
            </p>
          </button>
          <div className="flex items-center mb-2">
            <a href={`/friends/${authorId}`} className="flex items-center space-x-2">
              <img
                className="w-8 h-8 rounded-full mr-2"
                src={authorProfilePicture || process.env.PUBLIC_URL+"/profile_default.png"}
                alt="profile_picture_author"
              />
              <p className="text-sm mt-2 notranslate">
                {author}
              </p>
            </a>
            <p className="text-sm mt-2 ml-2 notranslate">
              {formatDateExtended(date)}
            </p>
            <button 
              type="button"
              onClick={() => setSelectedArticleIdForRecommendation(articleId)}
              className="ml-auto focus:outline-none"
            >
              <ArrowOutwardIcon />
            </button>
            <button 
              type="button"
              onClick={handleFavoriteClick}
              className="focus:outline-none"
            >
            <img 
              className="w-6 h-6 ml-2" 
              src={process.env.PUBLIC_URL + (isFavorite ? "/bookmark.svg" : "/bookmarklight.svg")} 
              alt="favoris"
            />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

  console.log(articles)
  console.log(reviews)
  
  return (
    <div className={`mt-8 ${isFrenchLanguage ? "notranslate" : ""}`} translate={isFrenchLanguage ? "no" : undefined}>
      <form onSubmit={handleSearch} className="flex w-full items-center mb-4">
        <div className="flex-grow ml-4 mr-2 mt-3">
          <input
            type="text"
            placeholder="Rechercher..."
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <button
          type="submit"
          className="bg-zemusbis hover:bg-zemushover text-white font-bold mt-3 mr-4 py-2 px-4 rounded-md whitespace-nowrap"
        >
          <SearchIcon />
        </button>
      </form>
      <div className="w-full flex justify-center flex-row p-2">
        <button
          type="button"
          style={{ backgroundColor: tab === "shared" ? '#c3e5ef' : "#009aad", color: tab === "shared" ? "black" : "white"}}
          className="w-full md:mr-4 mb-4 md:mb-0 p-2 shadow-sm transition-colors rounded mr-1"
          onClick={() => setTab("shared")}
          >
            Favoris partagés
        </button>
        <button
          type="button"
          style={{ backgroundColor: tab === "articles" ? '#c3e5ef' : "#009aad", color: tab === "articles" ? "black" : "white" }}
          className="w-full md:mr-4 mb-4 md:mb-0 p-2 shadow-sm transition-colors rounded"
          onClick={() => setTab("articles")}
          >
            Articles publiés	
        </button>
        <button
          type="button"
          style={{ backgroundColor: tab === "forums" ? '#c3e5ef' : "#009aad", color: tab === "forums" ? "black" : "white" }}
          className="w-full md:mr-4 mb-4 md:mb-0 p-2 shadow-sm transition-colors rounded ml-1"
          onClick={() => setTab("forums")}
          >
            Forums Globaux
        </button>
      </div>
      {
        showArticles && (
          <>
          <div className="flex justify-center text-center mb-4">
            <h2 className="text-2xl font-bold">{isUserSubscribed ? "Derniers articles publiés" : "Derniers articles publiés par mes amis"}</h2>
          </div>
          <select className="mb-4 p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ml-4" onChange={(e) => setArticleVisible(e.target.value)}>
            {PUBLISHED_VISIBILITY_OPTIONS.map((option) => (
              <option value={option.value} key={option.value}>{option.label}</option>
            ))}
          </select>
            {
              articleReady && articles.count === 0 && (
                <div className="flex justify-center text-center mb-4">
                  <h2 className="text-2xl font-bold">Aucun article trouvé</h2>
                </div>
              )
            }
          <div className="max-h-[50vh] overflow-y-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 ml-4 mr-4">
            {
              articleReady && articles.count > 0 && articles.rows.map((item) => (
                  <ArticleCard
                    key={item.id}
                    articleId={item.id}
                    imageUrl={item.featured_image}
                    author={item.firstname + " " + item.lastname}
                    authorProfilePicture={item.profile_picture}
                    authorId={item.user_id}
                    title={item.title}
                    text={removeHtmlTags(item.description)}
                    date={item.updated_at}
                    likesCount={item.likes_count}
                    commentsCount={item.comments_count}
                  />
              ))
            }
          </div>
          <Pagination
            itemsPerPage={articlesPerPage}
            totalItems={articles.count}
            paginate={articlePaginate}
            currentPage={currentArticlePage}
          />
          </>
        )
      }
      {
        tab === "shared" && (
          <>
          <div className="flex justify-center text-center mb-4">
            <h2 className="mt-2 text-2xl font-bold">{isUserSubscribed ? "Derniers favoris partagés" :"Derniers favoris partagés par mes amis"}</h2>
          </div>
            <select className="mb-4 p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ml-4" onChange={(e) => setReviewVisible(e.target.value)}>
              {PUBLISHED_VISIBILITY_OPTIONS.map((option) => (
                <option value={option.value} key={option.value}>{option.label}</option>
              ))}
            </select>
          <div className="max-h-[50vh] overflow-y-auto ml-4 mr-4 mb-8">
            {
              reviewsReady && reviews.count === 0 && (
                <div className="flex justify-center text-center mb-4">
                  <h2 className="text-2xl font-bold">Aucun favori partagé trouvé</h2>
                </div>
              )
            }
            {
              reviewsReady && reviews.count > 0 && 
              <ReviewBlocks reviews={reviews.rows} edition="false" displayAuthor={true} favorites={favorites} handleAddFav={handleArticleToFavorite} handleRemFav={handleRemoveFromFavorite} />
            }
          </div>
          
          <Pagination
            itemsPerPage={reviewsPerPage}
            totalItems={reviews.count}
            paginate={reviewPaginate}
            currentPage={currentReviewPage}
          />
        </>
        )
      }
      {tab === "forums" && <ForumFavorites />}
      <RecommendToFriendPopup
        isOpen={selectedArticleIdForRecommendation !== null}
        onClose={() => setSelectedArticleIdForRecommendation(null)}
        onConfirm={handleSendArticleNotification}
        title="Recommander à un ami"
      />
      
    </div>
  );
};

export default Feed;
